import { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import Footer from "../components/Footer";
import { ArrowBack } from "../components/CustomIcons";
import { Link, useNavigate, useParams } from "react-router-dom";
import { LeagueSteps } from "../constants/leagueLockerConfig";
import {
  getLeagueBySlug,
  updateLeagueProgressTrackerStatus,
} from "../components/leagueLocker/firestoreQuery";
import { useAuth } from "../contexts/AuthContext";

const ManageLeaguePage = () => {
  const navigate = useNavigate();
  const { leagueSlug } = useParams();
  const { user } = useAuth();

  const [isLoading, setIsLoading] = useState(true);
  const [leagueCompletedSteps, setLeagueCompletedSteps] = useState<string[]>(
    []
  );
  const [leagueId, setLeagueId] = useState("");
  const [leagueProgressTracker, setLeagueProgressTracker] = useState(false);

  useEffect(() => {
    const fetchLeagueDetails = async () => {
      if (leagueSlug) {
        try {
          setIsLoading(true);
          const res = await getLeagueBySlug(leagueSlug);
          if (res) {
            if (res.createdBy !== user?.uid) {
              navigate("/dashboard");
              return;
            } else {
              // Populate state with fetched data
              setLeagueId(res.id);
              setLeagueCompletedSteps(res.leagueCompletedSteps || []);
              setLeagueProgressTracker(res.leagueProgressTracker ?? false);
              setIsLoading(false);
            }
          } else {
            console.log("No league found with the provided slug.");
            navigate("/dashboard");
            setIsLoading(false);
          }
        } catch (error) {
          console.error("Error fetching league:", error);
          setIsLoading(false);
          //setErrorText(error as string);
        }
      }
      setIsLoading(false);
    };
    fetchLeagueDetails();
  }, [leagueSlug, leagueProgressTracker]);

  const checkEligibility = async () => {
    if (!leagueSlug) {
      return;
    }
    if (leagueSlug) {
      try {
        // Fetch league details logic here
        const res = await getLeagueBySlug(leagueSlug);
        if (res) {
          if (res.createdBy !== user?.uid) {
            navigate("/dashboard");
            return;
          }
        }
      } catch (error) {
        console.error("Error fetching league:", error);
      }
    }
  };

  useEffect(() => {
    checkEligibility();
  }, [leagueSlug]);

  const handleLeagueProgressTrackerDismissal = async () => {
    try {
      if (leagueId) {
        setLeagueProgressTracker(false);
        await updateLeagueProgressTrackerStatus(leagueId, false);
      }
    } catch (error) {
      console.error("Error updating league progress tracker:", error);
    }
  };

  return (
    <div className="pageOuterWrapper">
      <Navbar />
      <div className="contentArea otherContentArea">
        <div className="wrapper">
          <div className="backWrap">
            <Link to={`/${leagueSlug}/feed`}>
              <ArrowBack /> Back
            </Link>
          </div>
          <div className="yourLeagueHeader">
            <div className="headingItem">League Manager</div>
          </div>
          {leagueProgressTracker && (
            <div className="shadowBlk">
              <div className="blkHeading">
                ⭐️ <span>Finish setting up your league!</span>
                <button
                  className="underlineBtn"
                  onClick={handleLeagueProgressTrackerDismissal}
                >
                  Dismiss
                </button>
              </div>
              <div className="progressBlk">
                <div className="progressTxt">
                  {leagueCompletedSteps.length} of{" "}
                  {Object.keys(LeagueSteps).length} tasks completed!
                </div>
                <div className="progressBar">
                  <div
                    className="progressCompleted"
                    style={{
                      width: `${
                        (leagueCompletedSteps.length /
                          Object.keys(LeagueSteps).length) *
                        100
                      }%`,
                    }}
                  ></div>
                </div>
              </div>
              <ul className="stepsList">
                {LeagueSteps.map((step) => (
                  <li
                    className={
                      leagueCompletedSteps.includes(step.key)
                        ? `completedItem`
                        : ""
                    }
                    key={step.id}
                  >
                    {step.label}
                  </li>
                ))}
              </ul>
            </div>
          )}
          <ul className="leagueManageList">
            <li
              onClick={() => {
                navigate(`/manage-league/${leagueSlug}/edit-league`);
              }}
            >
              ✏️ Edit League Details
            </li>
            <li
              onClick={() => {
                navigate(`/manage-league/${leagueSlug}/edit-my-team`);
              }}
            >
              👤 Edit My Team
            </li>
            <li
              onClick={() =>
                navigate(`/manage-league/${leagueSlug}/edit-teams`)
              }
            >
              🏈 Edit Teams
            </li>
            <li
              onClick={() => {
                navigate(`/manage-league/${leagueSlug}/edit-rules`);
              }}
            >
              📚 Edit Rules
            </li>
            <li
              onClick={() => {
                navigate(`/manage-league/${leagueSlug}/manage-merch`);
              }}
            >
              🧢 Edit Merch
            </li>
          </ul>
          <button
            className="btnStyle btnFilled btnFull"
            onClick={() => {
              navigate(`/${leagueSlug}/feed`);
            }}
          >
            BACK TO LEAGUE
          </button>
        </div>
      </div>
      <Footer />
    </div>
  );
};

export default ManageLeaguePage;
